import React, { Component } from 'react';
import './Footer.scss';
// import logo from '../../assets/images/infomo.png';
import logo from '../../assets/images/logo.png';



class Footer extends Component {
    render() {
        const {
        } = this.props;
        return (
            <footer className="footer align-items-center d-flex">
                <div className="container-fluid clearfix">
                    <img src={logo} className="footer-logo" />
                    <div style={{ paddingTop: '9px' }} >&copy; {new Date().getFullYear()} Powered By TorcAI. - All rights reserved.</div>
                </div>
            </footer>
        );
    }
}

export default Footer;